export class ClusterNotFoundError extends Error {}
